import React from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { DataTable } from '@arnsbogroup/react-voicearchive'
import { useParams } from 'react-router-dom'
import { Timestamp, Span, Paragraph } from 'components/datatable'
import useApi from 'hooks/useApi'

export default () => {
  const { taskId } = useParams()
  const [entries,,, load] = useApi(`/rest/v1/actionLogEntry?search[taskid]=${taskId}&orderDirection=-1&orderField=uid&pageSize=10000`)

  return (
    <DataTable
      entries={entries}
      head={{
        crdate: { label: 'At' },
        message: { label: 'Event' },
        username: { label: 'By' },
      }}
      body={{
        crdate: Timestamp,
        message: ({message}) => <Paragraph dangerouslySetInnerHTML={{ __html: message }} />,
        username: Span,
      }}
    />
  )
}
